import { memo, useMemo } from "react";
import { SettingsMenuButton, SettingsMenuButtonContent, SidebarGroup } from "..";
import SettingsMenu from "./SettingsMenu";
import useSidebar from "../../SidebarProvider/useSidebar";
import { useTranslation } from "react-i18next";
import SettingsAvatar from "./SettingsAvatar";
import SettingMenuAction from "./SettingMenuAction";
import SettingsProfile from "./SettingsProfile";
import TooltipHelper from "components/TooltipHelper";
import useAnchorElement from "hooks/useAnchorElement";
import useSidebarRouteActive from "components/Sidebar/hooks/useSidebarRouteActive";
import Span from "components/primitives/Span";

function SettingsSectionControl() {
  const { open } = useSidebar();
  const { t } = useTranslation();
  const { isRouteActive } = useSidebarRouteActive();
  const { anchorElement, onRemoveAnchorElement, onSetAnchorElement } = useAnchorElement<HTMLElement>();

  const isActive = useMemo(() => isRouteActive("/settings"), [isRouteActive]);
  const menuOpened = Boolean(anchorElement);

  return (
    <SidebarGroup data-sidebar="group">
      <TooltipHelper placement="right" title={open ? null : t("global.settings_menu_label")}>
        <SettingsMenuButton
          id="settings-button"
          onClick={onSetAnchorElement}
          aria-label={t("global.settings_menu_label")}
          aria-controls={menuOpened ? "settings-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={menuOpened ? "true" : undefined}
        >
          <SettingsMenuButtonContent data-open={open} data-active={isActive}>
            <SettingsAvatar />
            <Span
              data-open={open}
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
                "&[data-open='false']": { display: "none" },
              }}
            >
              <SettingsProfile />
              <SettingMenuAction />
            </Span>
          </SettingsMenuButtonContent>
        </SettingsMenuButton>
      </TooltipHelper>
      <SettingsMenu anchorEl={anchorElement} open={menuOpened} onClose={onRemoveAnchorElement} />
    </SidebarGroup>
  );
}

export default memo(SettingsSectionControl);
